<template lang="html">
  <main>
    <h2>
      This is
      <h1>Admin Panel</h1>
      <router-link to="/login">
        LOGIN
      </router-link>
    </h2>
  </main>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>

main {

  &#content {
    flex-direction: column;
  }

  h2 {
    text-align: center;
  }

  a {
    text-decoration: underline;
  }

  .logo {
    width: 500px;
    height: auto;
    margin-bottom: 50px;
  }
}

</style>
